import { authHeader, httpHelper } from '../helpers';
import { post, get } from 'axios';

export const codeMngService = {
    addCode,
    modCode,
    delCode, 
};

function addCode(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/codemng/addCode`, formData, headers);
}

function modCode(formData){
    const headers = {headers: { ...authHeader(), 'Content-Type': 'application/json' }};
    return post(httpHelper.getApiUrl()+`/codemng/modCode`, formData, headers);
}

function delCode(code) {
    const headers = {headers: authHeader()};
    return get(httpHelper.getApiUrl()+`/codemng/delCode/${code}`, headers);
}